import React from "react"
import _ from "lodash"
// import { Helmet } from "react-helmet"
import capText from "~/tools/strings/capText"
import VideoJSPlayer from "~/components/VideoPlayer"
import popup from "~/views/Popup/popup"
import { trackEvent } from "~/tools/analytics/cleverTap"
import {
	getVideoInfo,
	addToQueue,
	removeFromQueue,
	getLikedStatus,
	getLikedCount,
	likeAVideo,
	dislikeAVideo
} from "~/redux/uservideo/helpers"
import { onUserAuth } from "~/redux/user/helpers"
import { getSearchedVideos } from "~/redux/video/helpers"
import { format, isPast } from "date-fns"
import { ThumbIcon, ClockIcon, Bookmark, CalendarIconNEOU, ShareIcon } from "~/assets/svg"
import get from "lodash/get";
import Timer from '~/components/Timer02';
import { addToCalendar } from "~/tools/addToCalendar";
import '~/assets/css/fitness-globals.scss';
import share from '~/tools/share';
import YouMayLikeTray from './components/youMayLikeTray';
import MoreClassesTray from './components/moreClassesTray';
import ConceptDetailSpan from './components/conceptDetailSpan';
import VideoWrapper from './components/videoWrapper';
import EquipmentItem from "./Equipment/EquipmentItem";
import {
	displayClassDuration,
	displayAiredDate
} from './helper'
import clockIconBig from '~/assets/images/clock-icon-big.png';
import connect from "~/tools/connect";
import userStore from "~/redux/user/store";
import "./style.scss";

const customVideoJSControls = {
	volumePanel: { inline: false },
	children: [
		"progressControl",
		"currentTimeDisplay",
		"timeDivider",
		"durationDisplay",
		"volumePanel",
		"fullscreenToggle"
	]
}

class VideoPlayerWithInfo04 extends React.Component {
	constructor(props) {
		super(props)
		this.data = props.data.contentData[0]
		this.settings = props.data.settings
		this.state = {
			similarShows: [],
			otherEpisodes: [],
			title: "",
			video: ((props.data || {}).contentData || [])[0],
			isQueued: false,
			startTime: 0,
			user: '',
			tags: _.get(this.data, "tags", []),
			optionalTags: _.get(this.data, "optionalTags", []),
			pricingOptions: _.get(props.data, "contentData[0].pricing"),
			isMobile: window.innerWidth <= 417,
			categoryTitle: "",
			liked: false,
			likedCount: 0,
			countDownTimer: null,
			brandLink: "",
			showTimer: true
		}
	}

	componentDidMount() {
		onUserAuth(() => this.fetchVideoInfo())
		const { isLiveStream, primaryCategory } = this.state.video.gist;
		if (
			isLiveStream &&
			this.state.video.gist.scheduleEndDate &&
			!isPast(this.state.video.gist.scheduleEndDate)
		) {
			this.interval = setInterval(this.checkDone, 1000)
			this.setState({ isLive: true })
		}


		const contentId = this.state.video.gist.id;
		const userId = this.state.user ? this.state.user.userId : null;
		getLikedCount(contentId).then(res => this.setState({ likedCount: res.Count }));
		userId && getLikedStatus(userId, contentId).then(res => this.setState({ liked: res.records.length > 0 }));

		this.getEpisodeInfo(contentId);
		this.getSimilarSeries(primaryCategory);

		window.addEventListener('resize', () => { this.setState({ isMobile: window.innerWidth <= 417 }) }, false)
	}

	fetchVideoInfo() {
		const id = this.data.gist.id;
		getVideoInfo(id, data =>
			this.setState({ isQueued: data.isQueued, startTime: data.watchedTime })
		);
	}

	addToQueue = () => {
		const { gist = {} } = this.state.video
		const id = gist.id
		const contentType = gist.contentType
		this.setState({ isQueued: true })

		addToQueue(id, contentType, data => {
			var addToQueueEventData = {
				contentId: gist.id,
				contentTitle: gist.title,
				contentType: gist.contentType,
				playbackType: "Streamed",
				networkType: "WiFi"
			}
			trackEvent("Removed From Watchlist", addToQueueEventData)
		}, () => { this.setState({ isQueued: false }) });
	}
	removeFromQueue = () => {
		const { gist = {} } = this.state.video
		const id = gist.id
		this.setState({ isQueued: false })

		removeFromQueue(id, data => {
			var removeFromQueueEventData = {
				contentId: gist.id,
				contentTitle: gist.title,
				contentType: gist.contentType,
				playbackType: "Streamed",
				networkType: "WiFi"
			}
			trackEvent("Removed From Watchlist", removeFromQueueEventData)
		}, () => { this.setState({ isQueued: true }) });
	}
	checkDone = () => {
		const { isLiveStream } = this.state.video.gist;
		if (
			isLiveStream &&
			this.state.video.gist.scheduleEndDate &&
			isPast(this.state.video.gist.scheduleEndDate)
		) {
			clearInterval(this.interval);
			this.setState({ isLiveDone: true, playVideo: false })
		}
	}

	getSquareLogo = (brand) => {
		let logoUrl = _.get(brand, "images._1x1.secureUrl");
		if (!logoUrl) {
			brand.badgeImages && brand.badgeImages.forEach(t => {
				if (t.imageType === '_1x1') {
					logoUrl = t.badgeImage.secureUrl
				}
			})
		}
		return logoUrl;
	}

	render() {
		const { gist, contentDetails, parentalRating, tags } = this.data,
			startTime = this.state.startTime,
			fileType = this.props.layout.settings.fileType,
			previewSettings = window.settings.features.free_preview,
			showPreview = previewSettings && previewSettings.isFreePreview,
			previewshowUnit = previewSettings && previewSettings.length.unit,
			previewShowTime = previewshowUnit === "Minutes" ? parseInt(previewSettings.length.multiplier, 10) * 60 : parseInt(previewSettings.length.multiplier, 10),
			brand = tags.find(t => t.tagType === "brand") || { title: '' },
			classDuration = tags.find(t => t.tagType === "classDuration") || {},
			classNumber = gist.metadata && gist.metadata.filter(item => item.name === "classNumber").map(e => e.value)[0],
			airDateTime = this.data.airDateTime,
			categoryTitle = _.get(gist.primaryCategory, "title", "") || {};
		return (
			<div className="videoplayer-with-info-04">
				<div className="video-header">
					<span className="icon-container" onClick={() => window.history.go(-1)}>
						<i className="ion-ios-arrow-thin-left"></i>
					</span>
					<div className="video-title">
						{this.state.title || ""}
					</div>
					<span className="icon-container" onClick={() => share.email(window.location.href)}>
						<ShareIcon />
					</span>
				</div>
				<div className="video-info-container">
					<section className="section-left">
						{
							// case 1: user not login
							!this.state.user ?
								<VideoWrapper gist={gist} user={this.state.user} type={"login"} />
								// case 2: user has logged in but current data is ealier than schedule start date
								: gist.scheduleStartDate && !isPast(gist.scheduleStartDate) && !this.state.playVideo ?
									<VideoWrapper
										gist={gist}
										user={this.state.user}
										login={true}
										renderLiveTimePrompt={this.renderLiveTimePrompt.bind(this)}
										type={"timer"}
									/>
									// case 3: user has logged in but this live has finished
									: this.state.isLiveDone ?
										<VideoWrapper gist={gist} user={this.state.user} type={"liveDone"} />
										// case 4: display normal video player
										: (<div className="videojs-player-container">
											<VideoJSPlayer
												{...this.state}
												customSkin={'./neouskin'}
												customControls={customVideoJSControls}
												videoId={gist.id}
												category={categoryTitle}
												fileType={fileType}
												isTrailer={false}
												autoplay={true}
												permalink={gist.permalink}
												previewTime={showPreview && previewShowTime}
												videoTag={_.get(window.settings, "advertising.videoTag")}
												parentalRating={parentalRating}
												showTimer={this.state.showTimer && this.createContainer()}
												isFree={gist.free}
												startTime={startTime}
												closedCaptions={contentDetails.closedCaptions}
												scheduleEndDate={gist.scheduleEndDate}
												isLive={this.state.isLive}
											/>
										</div>)
						}
						<div className="flex-row">
							<div className="concept-logo-container">
								<a href={this.state.brandLink || "#"} alt={`${this.state.title} link`}>
									<div className="concept-logo" style={{ backgroundImage: `url(${this.getSquareLogo(brand)})` }}></div>
								</a>
							</div>
							<div className="concept-data-container">
								{gist.primaryCategory && <div className="category-title">{`${gist.primaryCategory.title}`}</div>}
								<div className="video-title">{`${gist.title}`}</div>
								<div className="video-class-info">
									{classNumber} {displayAiredDate(classNumber, airDateTime)}
								</div>
								<div className="additional-info">
									<span className="video-duration">
										<ClockIcon /> {classDuration.title || displayClassDuration(this.state.video.gist.runtime)}
									</span>
									{!gist.scheduleStartDate && this.setupLikedSpan()}
								</div>
								{this.state.user && this.displayBookmarkOrCalendar(gist.scheduleStartDate, gist.scheduleEndDate)}
							</div>
						</div>
						<div className="flex-row">
							<div className="video-description">
								{gist.description}
							</div>
						</div>
					</section>
					<section className="section-right">
						{this.renderVideoMetada()}
						{this.renderVideoSetupInfo()}
						{this.renderClassFormat()}
					</section>
				</div>
				<div>
					{this.state.otherEpisodes.length > 0 && <MoreClassesTray data={this.state.otherEpisodes} title={this.state.title} />}
					{this.state.similarShows.length > 0 && <YouMayLikeTray data={this.state.similarShows} />}
				</div>
			</div>
		)
	}
	renderVideoMetada() {
		const { tags } = this.data,
			music = tags.filter(t => t.tagType === "musicType").map(item => item.title),
			difficulty = tags.filter(t => t.tagType === "difficulty").map(item => item.title) || [],
			bodyFocus = tags.filter(t => t.tagType === "bodyFocus").map(item => item.title) || [],
			intensity = tags.filter(t => t.tagType === 'intensity').map(item => item.title) || [],
			language = tags.filter(t => t.tagType === "language").map(item => item.title) || [],
			isExplicit = language[0] === 'Explicit' ? true : false

		return (
			<div className={"video-info flex-column"}>
				{difficulty.length > 0 && <ConceptDetailSpan data={difficulty} title={'DIFFICULTY'} />}
				{intensity.length > 0 && <ConceptDetailSpan data={intensity} title={'INTENSITY'} />}
				{bodyFocus.length > 0 && <ConceptDetailSpan data={bodyFocus} title={'BODY FOCUS'} />}
				{music.length > 0 && <ConceptDetailSpan data={music} title={'MUSIC'} />}
				{isExplicit && <ConceptDetailSpan data={['Contains explicit language']} classNames={'explicit'} />}
			</div>
		)
	}
	renderVideoSetupInfo() {
		const requiredEquipments = this.state.tags.filter(t => t.tagType === "equipment") || []
		const optionalEquipments = this.state.optionalTags.filter(t => t.tagType === "equipment") || []
		const hasOptional = optionalEquipments.length >= 1;
		const hasRequired = requiredEquipments.length >= 1;
		const noEquipmentRequired = !hasOptional && !hasRequired

		return (
			<div className="video-info">
				<div className="flex-row space-between">
					<div className="title">SET-UP</div>
					{(hasOptional || hasRequired) && <div className="hint">
						<span>
							<i className="hint-icon ion-asterisk required"></i> required
						</span>
						<span>
							<i className="hint-icon ion-record"></i> optional
						</span>
					</div>}
				</div>
				<div className="flex-row flex-wrap">
					{noEquipmentRequired ?
						<div className="equipment-setup-info-none">
							No Equipment Necessary!
						</div>
						:
						<div>
							{hasRequired && requiredEquipments.map(e => <EquipmentItem item={e} type='required' />)}
							{hasOptional && optionalEquipments.map(e => <EquipmentItem item={e} type='optional' />)}
						</div>

					}
				</div>
			</div>
		)
	}
	renderClassFormat() {
		let classFormat = _.get(this.state.video, "gist.longDescription");
		if (classFormat) {
			return (
				<div className="video-info">
					<div className="flex-row">
						<div className="title">Class Format</div>
					</div>
					<div className="flex-row">
						<div className="data">
							<p>
								{this.state.isMobile ? classFormat : capText(classFormat, 80)}
							</p>
							<button
								className="button cta"
								onClick={() => popup.customOverlay({
									renderContent: d => this.renderClassFormatContent(d),
									showCloseButton: false
								})}
							>
								<i className="icon ion-ios-list-outline"></i>
								View All Details
							</button>
						</div>
					</div>
				</div>
			)
		}
	}
	renderClassFormatContent({ renderCloseButton }) {
		const classFormat = _.get(this.state.video, "gist.longDescription")
		return (
			<div className="class-format-overlay-container">
				{renderCloseButton()}
				<div className="overlay-content">{classFormat}</div>
			</div>
		)
	}
	renderEquipmentItem = (e, type) => {
		const imgURL = get(e, "images._1x1.url");
		return (
			<div className={`flex-item space-between`} key={e.id}>
				<span className="item-image">{!!imgURL && <img src={get(e, "images._1x1.url")} alt={e.title} />}</span>
				<span>
					{e.title}
					{
						type === 'required' ?
							<i className="hint-icon ion-asterisk addSpaceLeft required"></i> :
							<i className="hint-icon ion-record addSpaceLeft"></i>
					}
				</span>
			</div>
		)
	}

	setUpLikedStatus(newCount, newLiked) {
		this.setState({
			likedCount: newCount >= 0 ? newCount : 0,
			liked: newLiked
		});
	}

	updateLikedStatusAndCount = () => {
		const { user, video, likedCount, liked } = this.state;
		const userId = user.userId;
		const contentId = video.gist.id;
		const contentType = video.gist.contentType;
		const title = video.gist.title;

		if (this.state.liked) {
			this.setUpLikedStatus(likedCount - 1, !liked)
			dislikeAVideo(userId, contentId)
				.then(res => { })
				.catch(err => {
					this.setUpLikedStatus(likedCount + 1, !liked)
				});
		} else {
			this.setUpLikedStatus(likedCount + 1, !liked)
			likeAVideo(userId, contentType, contentId, title)
				.then(res => { })
				.catch(err => {
					this.setUpLikedStatus(likedCount - 1, !liked)
				});
		}
	}

	setupLikedSpan() {
		let handleLike = this.state.user ? this.updateLikedStatusAndCount : () => popup.fitnessSignInCreate({
			showCloseButton: false
		});
		return <span className="video-rating">
			<button onClick={handleLike}>
				<ThumbIcon className={this.state.liked ? 'filled' : ``} />
			</button>
			{`${this.state.likedCount} LIKES`}
		</span>
	}

	renderLiveTimePrompt(startDate, endDate) {
		const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;
		const START_DATE = new Date(startDate);
		if (START_DATE - (new Date()) > TWENTY_FOUR_HOURS) {
			const week = format(START_DATE, 'ddd');
			const month_date = format(START_DATE, 'MMM D');
			const time = format(START_DATE, 'H:mm A')
			return `LIVE ${week}, ${month_date} at ${time}`;
		}
		return <Timer startDate={startDate} cb={this.startPlayVideo.bind(this)} />
	}

	startPlayVideo() {
		this.setState({ playVideo: true })
	}

	displayBookmarkOrCalendar(liveStartDate, liveEndDate) {
		if (liveStartDate) {
			if (!isPast(liveStartDate)) {
				return <span className="bookmark-icon" onClick={() => addToCalendar(this.state.video.gist)}>
					<CalendarIconNEOU />
				</span>
			}
			else if (isPast(liveStartDate) && !isPast(liveEndDate)) {
				return <span className="bookmark-icon liveNowBox">
					LIVE NOW
				</span>
			}

		} else {
			return <span className="bookmark-icon" onClick={this.state.isQueued ? this.removeFromQueue : this.addToQueue}>
				<Bookmark className={`${this.state.isQueued ? 'filled' : ''}`} />
			</span>
		}
	}

	getEpisodeInfo(contentId) {
		const videoTitle = this.state.video.gist.title;
		getSearchedVideos(null, null, null, null, null, contentId).then(data => {
			if (data) {
				const currentVideoId = this.state.video.gist.id;
				const filtedData = data.episodes.filter(e => e.gist.id != currentVideoId)
				this.setState({ otherEpisodes: filtedData, title: data.title, brandLink: data.permalink })
			}
			else {
				this.setState({ title: videoTitle })
			};
		})
	}

	getSimilarSeries(primaryCategory) {
		getSearchedVideos('series', 'category', primaryCategory.title || '').then(data => {
			this.setState({ similarShows: data, categoryTitle: primaryCategory.title || '' })
			if (data.length === 0) {
				getSearchedVideos('series', '', '').then(data => {
					this.setState({ similarShows: data, categoryTitle: primaryCategory.title || '' })
				})
			}
		})
	}

	createContainer = () => {
		const wrapper = document.createElement('div')
		const remainingTimeContainer = document.createElement('div')
		const timerIcon = document.createElement('img')
		const timerContainer = document.createElement('div');
		wrapper.className = 'remaining-time-wrapper'
		remainingTimeContainer.className = 'time-elapsed'
		timerIcon.className = 'timer-icon'
		timerContainer.className = 'timer-container'
		timerIcon.src = clockIconBig
		wrapper.append(timerContainer)
		timerContainer.append(timerIcon)
		timerContainer.append(remainingTimeContainer)
		return wrapper
	}
}

connect(
	VideoPlayerWithInfo04,
	state => ({ user: state.user }),
	userStore
);

export default VideoPlayerWithInfo04;